export default __webpack_public_path__ + "static/media/img-career-header.cf13dcde.jpg";